import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 工资
import sabill from "./sabill";
import salary from "./salary";

// 员工
import employee from './employee';
import empcontract from "./empcontract";

// 职位
import job from './job';

// 企业
import enterprise from "./enterprise";
import entercontract from "./entercontract";

// 主页
import home from "./home";

// 用户
import manager from './manager';
// 个人中心
import center from './center';
// 错误
import error from './error';
// 系统设置
import system from "./system";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'history',
    routes: [
        ...sabill,
        ...salary,

        ...employee,
        ...empcontract,

        ...job,

        ...enterprise,
        ...entercontract,

        ...home,

        ...manager,
        ...center,
        ...error,
        ...system,
    ],
});
